// auth.guard.ts
import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { UserApiService } from "./user.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private authService: UserApiService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const loginAuth = sessionStorage.getItem("login_response");
    if (loginAuth) this.authService.auth = JSON.parse(loginAuth);
    if (!this.authService.auth && this.isLocalTycPreview(state.url)) {
      this.authService.auth = this.getTycPreviewUser();
      sessionStorage.setItem("login_response", JSON.stringify(this.authService.auth));
    }
    if (!this.authService.auth || !this.authService.auth.access_token) {
      this.router.navigate(["/"]);
      return false;
    }
    return true;
  }

  private isLocalTycPreview(url: string): boolean {
    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    return isLocalhost && url.indexOf("previewTyc=true") >= 0;
  }

  private getTycPreviewUser(): any {
    return {
      access_token: "tyc-preview-token",
      expires_in: 3600,
      jti: "tyc-preview",
      refresh_token: "tyc-preview-refresh",
      scope: "read",
      someField: "",
      token_type: "bearer",
      roleDefinitions: [
        {
          rolename: "ROLE_NUTRITIONIST",
          modules: [
            { name: "paciente", read: true, create: true, update: true, delete: false },
            { name: "config.historia_clinica", read: true, create: true, update: true, delete: false },
          ],
        },
      ],
      userDetails: {
        enabled: true,
        id: "781",
        id_account: 392,
        id_person: "831",
        instituteId: "392",
        lastLogin: "",
        lastName: "Preview",
        licence: "1234",
        name: "TYC",
        password: "",
        retries: "0",
        roles: "ROLE_NUTRITIONIST",
        tc: false,
        username: "preview-tyc@local",
      },
    };
  }
}
